import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { FormGroup, AbstractControl } from '@angular/forms';
import { BaseComponent } from '../base/base.component';
import { MatSelect, MatSelectChange } from '@angular/material/select';

@Component({
  selector: 'app-lov',
  templateUrl: './lov.component.html',
  styleUrls: ['./lov.component.scss'],
})
export class LovComponent extends BaseComponent implements OnInit {

  @Input() form: FormGroup;
  @Input() controlName: string;
  @Input() label: string;
  @Input() hint?: string;//[OPTIONAL]
  @Input() noneLabel?: string;//label for the "none" option [OPTIONAL]
  @Output() onChange?: EventEmitter<any> = new EventEmitter();//[OPTIONAL]
  @Input("data") set setData(items: any[]) {

    if (items) {
      //even if the items are array sometimes angular throw an error that they are not an array.https://github.com/angular/angular/issues/6392
      this.data = Array.from(items);
    }
    this.prepareData();
  };
  //optional
  @Input("isRequired") set setIsRequired(value: boolean) {
    this.isRequired = value;
    this.form.get(this.controlName).setValue(null);//remove the value, must exist so form know if valid or not, keep using the actual form.get to make sure value is actually set
  };
  //optional
  @Input("value") set setValue(value: any) {

    this.value = value;
    this.form.get(this.controlName).setValue(this.value);//set value, keep using the actual form.get to make sure value is actually set
  };
  //optional, in case it is a simple data i.e. strings
  @Input("dataLabel") set setDataLabel(value: any) {
    this.dataLabel = value;
    this.prepareData();
  };
  //optional, in case it is a simple data i.e. strings
  @Input("secondaryDataLabel") set setSecondaryDataLabel(value: any) {
    this.secondaryDataLabel = value;
    this.prepareData();
  };
  @Input("isDisabled") set setIsDisabled(value: boolean) {

    this.isDisabled = value;
    if (this.isDisabled) {
      this.form.get(this.controlName).disable();
    } else {
      this.form.get(this.controlName).enable();
    }
  };

  @ViewChild('lovSelect') lovSelect: MatSelect;
  @ViewChild('searchElement', { read: ElementRef }) searchElement: ElementRef;

  data: any[];
  filteredData: any[];
  isRequired: boolean;
  isDisabled: boolean;
  control: AbstractControl;
  value: any;
  dataLabel: string;
  secondaryDataLabel: string;
  constructor() {
    super();
  }

  ngOnInit() {

    this.control = this.form.get(this.controlName);
    this.form.get(this.controlName).setValue(this.value);//set initial value if exists, keep using the actual form.get to make sure value is actually set
  }

  compareFn(obj1: any, obj2: any): boolean {

    return obj1 && obj2 ? obj1.rid === obj2.rid : obj1 === obj2;
  }

  onSelectionChange(matSelectChange: MatSelectChange) {

    this.onChange.emit(matSelectChange.value);
    this.resetSearch();
  }

  prepareData() {

    //pre data by doing some custom logic
    if (this.data && this.data.length > 0 && !this.util.isStringEmpty(this.dataLabel)) {
      for (let i = 0; i < this.data.length; i++) {
        let label = this.util.getDeepValue(this.data[i], this.dataLabel);
        if (!label && !this.util.isStringEmpty(this.secondaryDataLabel)) {
          label = this.util.getDeepValue(this.data[i], this.secondaryDataLabel);
        }
        this.data[i]["lovLabel"] = label;
      }
      this.resetSearch();
    }
    this.filteredData = this.data;
  }

  search(searchValue?: string) {
    if (!searchValue) {
      this.filteredData = this.data;
    } else {
      this.filteredData = this.data.filter(item => item.lovLabel.toLowerCase().indexOf(searchValue.toLowerCase()) >= 0);
    }
  }

  resetSearch() {
    if (this.searchElement) {
      this.searchElement.nativeElement.value = "";
    }
    this.search();
  }

  openEvent(open: boolean) {
    if (open) {
      //onOpen
      if (!this.util.isMobile()) {
        this.searchElement.nativeElement.focus();
      }
    } else {
      //onClose
      this.resetSearch();
    }
  }

  selectFirst() {
    if (this.filteredData[0]) {
      this.value = this.filteredData[0];
      this.form.get(this.controlName).setValue(this.value);
      this.onChange.emit(this.value);
      this.resetSearch();
      this.lovSelect.close();
    }
  }

}
